import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from '../LandingPage/FallbackPage';
import { ASSET_NAME } from './ReturnPolicyPage.duck';
import css from './ReturnPolicyPage.module.css';
import BackgroundLines from '../../components/Cobe/BackgroundLines/BackgroundLines';
import { FormattedMessage } from '../../util/reactIntl';
import ReturnPolicy from '../../components/Cobe/ReturnPolicy/ReturnPolicy';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const ReturnPolicyPageComponent = props => {
  const {
    pageAssetsData,
    inProgress,
    error,
    fetchInProgress,
  } = props;

  if (fetchInProgress) {
    return null;
  }

  return (
    <>
      <PageBuilder
        pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
        inProgress={inProgress}
        error={error}
        fallbackPage={<FallbackPage error={error} />}
      >
        <section className={css.mainWrap}>
          {/* <BackgroundLines /> */}

          <div className={css.container}>
            <ReturnPolicy />
          </div>
        </section>
      </PageBuilder>
    </>
  );
};

ReturnPolicyPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { currentUser } = state.user;

  return {
    pageAssetsData,
    inProgress,
    error,
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ReturnPolicyPage = compose(connect(mapStateToProps))(ReturnPolicyPageComponent);

export default ReturnPolicyPage;
